import { useEffect, useRef } from 'react'
import type { TaiwanHostedGatewayData } from '../../../types/taiwan.types'

// Auto-submitting hidden form that hands the customer off to the hosted gateway
// (2c2p). Every field of the gateway payload becomes a hidden input except
// `payment_action_url`, which is the POST target. Mirrors the legacy
// RedirectPaymentGateway behaviour.
export default function RedirectPaymentGateway({ data }: { data: TaiwanHostedGatewayData }) {
    const formRef = useRef<HTMLFormElement>(null)
    const { payment_action_url, ...fields } = data

    useEffect(() => {
        formRef.current?.submit()
    }, [])

    return (
        <form
            ref={formRef}
            method="POST"
            id="payment-gateway-form"
            action={payment_action_url}
            style={{ display: 'none' }}
            data-testid="taiwan-payment-redirect-form">
            {Object.entries(fields).map(([key, value]) => (value === undefined ? null : <input type="hidden" name={key} value={String(value)} key={key} />))}
        </form>
    )
}
